import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	pageUntitledDraft: {
		id: 'linkCreate.CreateConfluencePage.create.page.untitled.draft',
		defaultMessage: 'Draft: Untitled',
		description: 'Place holder text when default Parent Page has no title',
	},
	contentOptionLabel: {
		id: 'linkCreate.CreateConfluencePage.create.content.label',
		defaultMessage: 'Content',
		description: 'Label for confluence content items in confluence link create select menu',
	},
	spacesOptionLabel: {
		id: 'linkCreate.CreateConfluencePage.create.spaces.label',
		defaultMessage: 'Spaces',
		description: 'Label for confluence space items in confluence link create select menu',
	},
});
